import Pusher from 'pusher-js'

class WebSocketService {
	private pusher!: Pusher
	private PUSHER_KEY = process.env.VUE_APP_PUSHER_KEY
	private PUSHER_OPTIONS = { cluster: 'us2' }
	static instance: WebSocketService;

	constructor() {
		if (!WebSocketService.instance) {

			this.pusher = new Pusher(this.PUSHER_KEY, this.PUSHER_OPTIONS);

			setTimeout(() => {
				const state = this.pusher.connection.state;
				if (state !== "connected") {
					console.error("DEU RUIM NO PUSHER");
				}
			}, 15000);

			WebSocketService.instance = this;
		}

		return WebSocketService.instance;
	}

	connect = () => {
		this.pusher.connect();
	};

	subscribe = (value: string) => {
		return this.pusher?.subscribe(value);
	}

	unsubscribe = (channelName: string, eventName: string) => {
		this.pusher.unsubscribe(channelName)
		this.pusher.unbind(eventName)
	}

	disconnect = () => {
		this.pusher.disconnect();
	};
}

const webSocketService = new WebSocketService();
export default webSocketService;


// import Pusher from 'pusher-js'

// export default class WebSocketService {
// 	constructor() { }
// 	getInstance() {
// 		return new Pusher(process.env.VUE_APP_PUSHER_KEY, {
// 			cluster: 'us2'
// 		});
// 	}
// }
